import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  clients: [],
  selectedClient: null,
  clientApps: [],
  clientScripts: [],
  clientStats: null,
  connectionStatus: null,
  searchTerm: "",
  envFilter: "all",
  statusFilter: "all",
  loading: false,
  appsLoading: false,
  scriptsLoading: false,
  statsLoading: false,
  connectionLoading: false,
  error: null,
  // [9a-endpoint-fix] Distinguish "load failed" from "legitimately zero apps"
  appsError: null,
};

const clientsSlice = createSlice({
  name: "clients",
  initialState,
  reducers: {
    fetchClientsStart(state) {
      state.loading = true;
      state.error = null;
    },
    fetchClientsSuccess(state, action) {
      state.clients = action.payload;
      state.loading = false;
    },
    fetchClientsFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    setSelectedClient(state, action) {
      state.selectedClient = action.payload;
      state.clientApps = [];
      state.clientScripts = [];
      state.clientStats = null;
      state.connectionStatus = null;
      state.appsError = null;
    },
    clearSelectedClient(state) {
      state.selectedClient = null;
      state.clientApps = [];
      state.clientScripts = [];
      state.clientStats = null;
      state.connectionStatus = null;
      state.appsError = null;
    },
    fetchClientAppsStart(state) {
      state.appsLoading = true;
      state.appsError = null;
    },
    fetchClientAppsSuccess(state, action) {
      state.clientApps = action.payload;
      state.appsLoading = false;
      state.appsError = null;
    },
    fetchClientAppsFailure(state, action) {
      state.appsLoading = false;
      // [9a-endpoint-fix] Do NOT reset clientApps here — wiping on failure
      // hides real errors behind an innocent-looking "0" count.
      state.appsError = action.payload;
      state.error = action.payload;
    },
    fetchClientScriptsStart(state) {
      state.scriptsLoading = true;
    },
    fetchClientScriptsSuccess(state, action) {
      state.clientScripts = action.payload;
      state.scriptsLoading = false;
    },
    fetchClientScriptsFailure(state, action) {
      state.scriptsLoading = false;
      state.clientScripts = [];
      state.error = action.payload;
    },
    fetchClientStatsStart(state) {
      state.statsLoading = true;
    },
    fetchClientStatsSuccess(state, action) {
      state.clientStats = action.payload;
      state.statsLoading = false;
    },
    fetchClientStatsFailure(state, action) {
      state.statsLoading = false;
      state.clientStats = null;
    },
    testConnectionStart(state) {
      state.connectionLoading = true;
      state.connectionStatus = null;
    },
    testConnectionSuccess(state, action) {
      state.connectionStatus = action.payload;
      state.connectionLoading = false;
    },
    testConnectionFailure(state, action) {
      state.connectionStatus = { reachable: false, error: action.payload };
      state.connectionLoading = false;
    },
    setSearchTerm(state, action) {
      state.searchTerm = action.payload;
    },
    setEnvFilter(state, action) {
      state.envFilter = action.payload;
    },
    setStatusFilter(state, action) {
      state.statusFilter = action.payload;
    },
  },
});

export const {
  fetchClientsStart,
  fetchClientsSuccess,
  fetchClientsFailure,
  setSelectedClient,
  clearSelectedClient,
  fetchClientAppsStart,
  fetchClientAppsSuccess,
  fetchClientAppsFailure,
  fetchClientScriptsStart,
  fetchClientScriptsSuccess,
  fetchClientScriptsFailure,
  fetchClientStatsStart,
  fetchClientStatsSuccess,
  fetchClientStatsFailure,
  testConnectionStart,
  testConnectionSuccess,
  testConnectionFailure,
  setSearchTerm,
  setEnvFilter,
  setStatusFilter,
} = clientsSlice.actions;

export default clientsSlice.reducer;
